import { LinkedFieldWithLayoutSettings } from '@Components/LinkedFieldWithLayoutSettings';
import { ledgerAccountColumns, vatColumns } from '@Constants/TableColumns';
import {
    ApiAccountsGroup,
    allAccountGroupOptions,
    EnumFrontendLayoutSetting,
    type ApiLedgerAccount,
    type ApiService,
    type ApiVat,
} from '@Model';
import { FrameEditLedgerAccount, FrameEditVat } from '@Modules/Stammdaten';
import {
    Badge,
    Grid,
    GridColumns,
    type IGuiBinder,
    type Index,
    InfoIcon,
    type ISubFrameBodyProps,
    UnlabeledField,
    useGuiBinder,
    useLinkedField,
} from '@synqo/frontend-component-library';

interface IEditAccountGroupsProperties extends ISubFrameBodyProps<ApiAccountsGroup> {
    binder: IGuiBinder<ApiService>;
    accountGroupPropertyName: Index<ApiService>;
    infoTooltip?: string;
}

export function FrameEditAccountGroups(props: IEditAccountGroupsProperties) {
    const apiAccountGroup = props.data;

    const binder = useGuiBinder(props);

    const apiAccountGroupLabel = allAccountGroupOptions.find((o) => o.value == apiAccountGroup.account_group)?.label;

    const linkLedgerAccount = useLinkedField(
        `${props.apiResourcePath}/${props.accountGroupPropertyName}`,
        'ledger_account',
        FrameEditLedgerAccount,
        true,
        props.requestUpdateState,
    );
    const linkVat = useLinkedField(
        `${props.apiResourcePath}/${props.accountGroupPropertyName}`,
        'vat',
        FrameEditVat,
        true,
        props.requestUpdateState,
    );

    return (
        <Grid columns={14}>
            <GridColumns spans={[5, 5, 4]}>
                <UnlabeledField>
                    <Badge key="info_tooltip" size="sm" variant="primary" type="input">
                        {apiAccountGroupLabel}
                        {props.infoTooltip?.length ? (
                            <>
                                &nbsp;
                                <InfoIcon tooltip={props.infoTooltip} />
                            </>
                        ) : (
                            ''
                        )}
                    </Badge>
                </UnlabeledField>
                <LinkedFieldWithLayoutSettings<ApiLedgerAccount>
                    layoutSettingsContext={EnumFrontendLayoutSetting.LedgerAccountsTableLayout}
                    {...binder.bindToLinkProperty(linkLedgerAccount.linkApi)}
                    {...linkLedgerAccount.events}
                    columns={ledgerAccountColumns}
                    label="Sachkonto"
                    queryKey={[props.apiResourcePath, props.accountGroupPropertyName]}
                />
                <LinkedFieldWithLayoutSettings<ApiVat>
                    layoutSettingsContext={EnumFrontendLayoutSetting.VatsTableLayout}
                    {...binder.bindToLinkProperty(linkVat.linkApi)}
                    {...linkVat.events}
                    columns={vatColumns}
                    label="MwSt"
                    queryKey={[props.apiResourcePath, props.accountGroupPropertyName]}
                />
            </GridColumns>
        </Grid>
    );
}
